import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../services/config-service/config-service.service';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { WorkflowFormsService } from '../../../services/workflow-forms/workflow-forms.service';
import { bulkPaymentsCtaValidationMap } from './cta-validations/bulk-payments-validations';
import { documentValidationMap } from './cta-validations/document-validations';
import { KycVerificationCtasValidationMap } from './cta-validations/kyc-verification-validations';
import { profileCTAsValidationMap } from './cta-validations/profile-actions-validations';
import { onboardingCtaValidationMap } from './cta-validations/onboarding-validations';
import { savingsAccountCtaValidationMap } from './cta-validations/savings-account-validations';
import { updateUserProfileCtaValidationMap } from './cta-validations/user-profile-validation';

export const ctaButtonValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
    configService?: ConfigService,
    workflowFormsService?: WorkflowFormsService,
  ) => Observable<any>
> = new Map<ButtonActionType, any>([
  ...Array.from(bulkPaymentsCtaValidationMap.entries()),
  ...Array.from(KycVerificationCtasValidationMap.entries()),
  ...Array.from(documentValidationMap.entries()),
  ...Array.from(profileCTAsValidationMap.entries()),
  ...Array.from(onboardingCtaValidationMap.entries()),
  ...Array.from(savingsAccountCtaValidationMap.entries()),
  ...Array.from(updateUserProfileCtaValidationMap.entries()),
]);
